import {styled} from '@mui/material/styles';

interface IFrameProps {
  styles?: React.CSSProperties;
  isApp?: boolean;
}

export const StyledIFrame = styled('iframe')(({styles, isApp}: IFrameProps) => ({
  '&.iframeCarousel': {
    width: '100%',
    backgroundColor: 'transparent',
    border: 'none',
    minHeight: isApp ? '420px' : '500px',
    visibility: 'visible',
    overflowY: 'auto',
    overflowX: 'hidden',
    ...styles
  }
}));
